import React, { useState } from 'react'
import "./index.less"
import PageHead from '@/components/PageHead'
import SafetyWarning from '@/components/SafetyWarning'
import { useTranslation } from 'react-i18next'
import { Alert, Divider, Input, InputNumber, message, Pagination } from 'antd'
import { cdnUrl } from '@/utils/cdn'
import { Ed25519Keypair } from '@mysten/sui/keypairs/ed25519';
import { downloadFile } from '@/utils/downloadFile'
export default function BatchWalletGenerate() {
  const { t } = useTranslation();
  const [walletLists, setWalletLists] = useState<any>([]);
  const [generateNumber, setGenerateNumber] = useState<any>(1);
  const [currentPage, setCurrentPage] = useState(1);   // ✅ 当前页
  const copy = async (content: any) => {
    await navigator.clipboard.writeText(content);
    message.success(t("tips.copy"));
  };
  const pageSize = 5;                                  // ✅ 每页条数
  console.log("walletLists", walletLists)
  function isNumber(value: any) {
    return typeof value === 'number' && !Number.isNaN(value);
  }
  async function generateWallets(count: number) {
    // 请正确填写要生成的钱包地址数量
    if (!count) {
      message.error(t("walletGenerator.addressCountError"))
      return
    }
    if (!isNumber(count)) {
      message.error(t("walletGenerator.addressCountError"))
      return
    }
    setWalletLists([])
    for (let i = 0; i < count; i++) {
      const keypair = new Ed25519Keypair();
      const address = keypair.getPublicKey().toSuiAddress();

      const secretKeyBytes = keypair.getSecretKey(); // Uint8Array
      const secretKeyHex = Buffer.from(secretKeyBytes).toString('hex');
      // const secretKeyB64 = Buffer.from(secretKeyBytes).toString('base64');
      const privateKey = Buffer.from(secretKeyHex, 'hex').toString('utf8');
      // list.push({
      //   index: i,
      //   address,
      //   privateKey,
      // });
      setWalletLists((prev: any) => [...prev, { index: i + 1, address, privateKey }]);
      await new Promise((resolve, reject) => { setTimeout(() => { resolve(true) }, 0.1) })
    }
  }
  const downloadFileFun = () => {
    downloadFile(walletLists, "xlsx")
  }
  const copy1 = async (content: any) => {
    try {
      const text =
        typeof content === 'string'
          ? content
          : JSON.stringify(content, null, 2); // 格式化 JSON，复制更好看

      await navigator.clipboard.writeText(text);
      message.success(t("tips.copy"));
    } catch (e) {
      console.error(e);
      message.error(t("tips.copyFail"));
    }
  };
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentPageData = walletLists.slice(startIndex, endIndex);
  return (
    <div className='page-content batch-wallet-generate-wrap'>
      <PageHead title={t("walletGenerator.title", { "chain": "SUI" })} desc={t("walletGenerator.desc", { "chain": "SUI" })} >
        <SafetyWarning />
      </PageHead>
      <div className='input-section'>
        {/* 生成的钱包地址数量 */}
        <div className='title'>{t("walletGenerator.addressCountLabel")}</div>
        <Input className='cus-ipt' value={generateNumber} onChange={(e) => { setGenerateNumber(e.target.value) }} suffix={<div className='input-btn'>
          <button onClick={() => { setGenerateNumber(100) }}>100</button>
          <button onClick={() => { setGenerateNumber(5000) }}>Max</button>
        </div>}></Input>
      </div>
      <div className='hint'>
        <Alert
          message={
            <div>
              {/* "提示：您的钱包生成过程完全在本地电脑上进行，确保您的私钥始终处于您的掌控之中。 */}
              {t("walletGenerator.localSecurityTip")}
            </div>
          }
          type="warning"
          showIcon
          closable
          className="cus-alert"
        />
      </div>
      {/* 立即生成 */}
      <button className='start-btn' onClick={() => {
        generateWallets(Number(generateNumber));
      }}>{t("walletGenerator.generateNow")}</button>
      {walletLists.length > 0 && <div className='wallet-table'>
        <div className='table-header'>
          <div className='left'>
            {t("walletGenerator.progress")}：{walletLists.length}/{generateNumber}
          </div>
          {/* 下载表格 */}
          <button className='right' onClick={downloadFileFun}>{t("walletGenerator.downloadSheet")}</button>
        </div>
        <Divider></Divider>
        <div className='table-content'>
          {currentPageData.map((item: any) => {
            return (
              <div className='single-wallet-item' key={item.index}>
                <div className='header'>
                  {/* 钱包 */}
                  <div className='wallet-index'>{t("walletGenerator.wallet")} {item.index}</div>
                  {/* 复制全部 */}
                  <button className='copy-btn' onClick={() => { copy1(item) }}>{t("walletGenerator.copyAll")}</button>
                </div>
                <div className='divider'></div>
                <div className='info'>
                  <div className='item'>
                    {/* 地址 */}
                    <div className='col1'>{t("walletGenerator.address")}:</div>
                    <div className='col2'>{item.address}</div>
                    <img src={cdnUrl("/img/999999copy.svg")} alt="" onClick={() => { copy(item.address) }} />
                  </div>
                  <div className='item'>
                    <div className='col1'>{t("walletGenerator.privateKey")}:</div>
                    <div className='col2'>{item.privateKey}</div>
                    <img src={cdnUrl("/img/999999copy.svg")} alt="" onClick={() => { copy(item.privateKey) }} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className='pagenation'> <Pagination defaultPageSize={5} total={walletLists.length} onChange={(page) => setCurrentPage(page)} showSizeChanger={false} /></div>
      </div>}
    </div>
  )
}
